import React, { createContext, Component } from 'react'

const LoadingContext = createContext()

const { Provider, Consumer } = LoadingContext

export class LoaderProvider extends Component {
    state = {
        loading: false,
    }

    setLoading = () => this.setState({ loading: true })
    setUnloading = () => this.setState({ loading: false })

    render = () => {
        const { loading } = this.state
        return (
            <Provider
                value={{
                    loading,
                    setLoading: this.setLoading,
                    setUnloading: this.setUnloading,
                }}
            >
                {this.props.children}
            </Provider>
        )
    }
}

export const LoaderConsumer = Comp => props => (
    <Consumer>{context => <Comp {...props} {...context} />}</Consumer>
)
